import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=logged out

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, reload: load, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

export function can(user, module, action) {
  const p = user?.permissions || {};
  if (p["*"]?.includes("*")) return true;
  return (p[module] || []).includes(action);
}

export function canSensitive(user, key) {
  const p = user?.permissions || {};
  if (p["*"]?.includes("*")) return true;
  return (p.sensitive || []).includes(key);
}
